import React, { Fragment } from "react";
import { DollarSign, FileText, ShoppingBag, Users } from "react-feather";
import { Card, CardBody, Col } from "reactstrap";
import { H3, P } from "../../../AbstractElements";
import { IncomeChart, OrderChart, SalesChart, VisitorChart } from "../../../Data/Dashboard/Ecommerce/Chart";
import Chart from "react-apexcharts";

const SaleChart = ({ list }) => {
  const data = [
    { id: 1, name: 'Total Subscription', icon: <Users />, value: list?.totalSubscriptions, chart: VisitorChart },
    { id: 2, name: 'Total Sales', icon: <ShoppingBag />, value: list?.totalSale, chart: SalesChart },
    { id: 3, name: 'Total Income', icon: <DollarSign />, value: list?.totalIncome, chart: IncomeChart },
    { id: 4, name: 'Total Dues', icon: <FileText />, value: list?.totalDues, chart: OrderChart },
  ];

  return (
    <Fragment>
      {data.map((item, i) => (
        <Col lg="3" sm="6" key={i}>
          <Card className="sale-chart">
            <CardBody>

              {/* TOP ROW WITH ICON + NAME + VALUE */}
              <div className="d-flex align-items-center justify-content-between mb-2">

                {/* Icon */}
                <div className="icon me-2" style={{ fontSize: "22px" }}>
                  {item.icon}
                </div>

                {/* Name + Value */}
                <div className="text-start">
                  <H3 className="mb-0" style={{ fontSize: "16px" }}>{item.name}</H3>
                  <P className="mb-0" style={{ fontSize: "14px" }}>₹{item.value}</P>
                </div>

              </div>

              {/* CHART */}
              <div style={{ width: "100%", height: "80px", overflow: "hidden" }}>
                <Chart
                  options={{
                    ...item.chart.options,
                    stroke: { curve: "smooth", width: 2 },
                    toolbar: { show: false },
                    grid: { show: false },
                  }}
                  series={item.chart.series}
                  type="line"
                  height={80}
                />
              </div>

            </CardBody>
          </Card>
        </Col>
      ))}
    </Fragment>
  );
};

export default SaleChart;
